"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _environmentIndicatorModule = _interopRequireDefault(require("./environmentIndicator.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnvironmentIndicator = function EnvironmentIndicator(props) {
  var country = props.country,
      envName = props.envName;
  return _react.default.createElement("div", {
    className: _environmentIndicatorModule.default["env-indicator-".concat(envName.toLowerCase())]
  }, _react.default.createElement("span", {
    className: _environmentIndicatorModule.default["env-flag-".concat(country.toLowerCase())]
  }), _react.default.createElement("span", {
    className: _environmentIndicatorModule.default["env-name"]
  }, "".concat(country, " ").concat(envName)));
};

EnvironmentIndicator.propTypes = {
  /** String text that specifies the country the software is deployed at (Software DEV, UK, Ireland, Canada) */
  country: _propTypes.default.string,

  /** String text that specifies the environment the software is used at (PR, DEV, SIT, UAT, SANDBOX, LIVE) */
  envName: _propTypes.default.string
};
var _default = EnvironmentIndicator;
exports.default = _default;